import { render, staticRenderFns } from "./resendVIP.vue?vue&type=template&id=18d22570&scoped=true&"
import script from "./resendVIP.vue?vue&type=script&lang=js&"
export * from "./resendVIP.vue?vue&type=script&lang=js&"
import style0 from "./resendVIP.vue?vue&type=style&index=0&id=18d22570&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d22570",
  null
  
)

export default component.exports